import { render, staticRenderFns } from "./PlayerMange.vue?vue&type=template&id=432fc805&scoped=true&"
import script from "./PlayerMange.vue?vue&type=script&lang=js&"
export * from "./PlayerMange.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMange.vue?vue&type=style&index=0&id=432fc805&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432fc805",
  null
  
)

export default component.exports